var React = require('react');

function Inhaler (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M32 448a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96-144a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-96-48a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm0 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96 48a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM616.27 38L478.47 1.1a32 32 0 0 0-39.19 22.63l-15.41 57.52L592.61 250 638.9 77.21A32 32 0 0 0 616.27 38z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M586.15 288.78a32 32 0 0 1 8.33 30.75l-44.22 168.59a32 32 0 0 1-31 23.88H224a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32h122.49l35.91-136.92a16 16 0 0 1 26.79-7.26z","className":"fa-primary","key":2})]);
}

Inhaler.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Inhaler;

Inhaler.default = Inhaler;
